import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import UserDetails from './UserDetails'

function UserDetailsContainer() {
  return (
    <MainLayout navTitle={"User Details"} navSubTitle={"Welcome to Cotton Slice"}>
      <UserDetails/>
    </MainLayout>
  )
}

export default UserDetailsContainer